export const translateType = (value: string, t: (key: string) => string) => {
  switch (value) {
    case 'EligibilityAudit':
      return t('intervention.audit');
    case 'AttributeInstall':
      return t('intervention.installAttribute');
    case 'AttributeMaintenance':
      return t('intervention.maintenanceAttribute');
    case 'MeterInstall':
      return t('intervention.installMeter');
    case 'MeterMaintenance':
      return t('intervention.maintenanceMeter');
    case 'DeviceInstall':
      return t('intervention.installDevice');
    case 'DeviceDump':
      return t('intervention.removeDevice');
    case 'DeviceReinstall':
      return t('intervention.reinstallDevice');
    case 'DeviceMaintenance':
      return t('intervention.maintenanceDevice');
    case 'RepeaterMaintenance':
      return t('intervention.maintenanceRepeater');
    case 'VisualIndex':
      return t('intervention.visualRead');
    case 'RadioIndex':
      return t('intervention.radioRead');
    case 'DeviceUpdate':
      return t('intervention.deviceUpdate');
    case 'RepeaterUpdate':
      return t('intervention.repeaterUpdate');
    case 'MeterMaintenanceWithCS':
      return t('intervention.maintenanceMeterWithSurvey');
    case 'DeviceMaintenanceWithCS':
      return t('intervention.maintenanceDeviceWithSurvey');
    case 'MeterInstallWithCS':
      return t('intervention.installMeterWithSurvey');
    case 'DeviceInstallWithCS':
      return t('intervention.installDeviceWithSurvey');
    case 'ConnectionSurveyWithCS':
      return t('intervention.connectionSurvey');
    case 'DeviceInstallLight':
      return t('intervention.installDeviceLight');
    case 'DeviceMaintenanceLight':
      return t('intervention.maintenanceDeviceLight');
    case 'RadioIndexRead':
      return t('intervention.unitaryRadioRead');
    case 'QuickUpdate':
      return t('intervention.quickUpdate');
    default:
      return value;
  }
};
